import { faSave } from "@fortawesome/free-solid-svg-icons"
import { useState } from "react"
import { AtualizaContratoController, ListaContratoStatusController } from "../../../../Controllers/Geral/ContratosGerados/ContratosGeradosController"
import { IContratosGerados, IContratosStatus } from "../../../../Interfaces/Geral/ContratosGerados/ContratosGeradosInterface"
import UnForm from "../../../Form"

interface IAlterarStatusContrato {
    setShow: (show: boolean) => void
    then: () => void
    Contrato: IContratosGerados
}



export default function EditarStatusContrato(props: IAlterarStatusContrato) {
    const [loading, setLoading] = useState(false)

    function handleStatusContratoFormSubmit(formData: IContratosStatus) {
        setLoading(true)
        AtualizaContratoController({
            ...props.Contrato,
            ID_CONTRATO_STATUS: formData.ID_CONTRATO_STATUS,
            DS_CONTRATO_STATUS: ""
        })
            .then((result) => {
                if (result.isConfirmed) {
                    loading.valueOf()
                }
            })
            .finally(() => {
                setLoading(false)
            })
            .then(props.then)
    }

    return (
        <div className="w-100 align-itens-center">
            {
                <UnForm handleSubmit={handleStatusContratoFormSubmit}>
                    <div className="form-group">
                        <div className="col-12 col-lg-12 mt-2">
                            <UnForm.LazySelect
                                controller={ListaContratoStatusController}
                                getDS={ca => ca.DS_CONTRATO_STATUS}
                                getKeyValue={ca => ca.ID_CONTRATO_STATUS}
                                name="ID_CONTRATO_STATUS"
                                label="Status do contrato"
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                    </div>
                    <UnForm.SubmitButton className="col-8 col-lg-12 " type="submit" icon={faSave} color="success">Salvar</UnForm.SubmitButton>
                </UnForm>
            }
        </div>
    )
}